import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { boardFocusAreas } from '../data/boardFocus';
export function BoardPositioning() {
  return <section id="board" className="bg-navy py-24 lg:py-32" data-id="element-43" data-mp="1lx0c4qi1x6sz">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-44" data-mp="1lvgxf4c1n3tb">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-16 items-start" data-id="element-45" data-mp="1qpblsl2lg6yq">
          <SectionHeading eyebrow="04 — Board Positioning" title="Positioned for Board-Level Impact" description="Ready for Chief Executive Officer, Non-Executive Director, and Advisory Board appointments — bringing governance discipline, risk oversight, and strategic adaptability to complex global media ecosystems facing market disruption." tone="light" data-id="element-46" data-mp="1uqdhirxay0vy" />

          <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10" data-id="element-47" data-mp="ab205ypqkwbl">
            {boardFocusAreas.map((area, index) => {
            const Icon = area.icon;
            return <motion.div key={area.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.5,
              ease: [0.23, 1, 0.32, 1],
              delay: index * 0.06
            }} className="bg-navy p-8" data-id="element-48" data-mp="1o99qtasjh7vy" data-mpi={index}>
                  <Icon className="h-6 w-6 text-gold" strokeWidth={1.5} data-id="element-49" data-mp="276ay529kfk32" />
                  <h3 className="mt-4 font-serif text-lg font-semibold text-white" data-id="element-50" data-mp="228ixnjuuupn9">{area.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400" data-id="element-51" data-mp="1x8wj973aj3cv">{area.description}</p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}